import React from 'react';

import LazyPage from '@classes/lazyPage/LazyPage';

import PublicI from '../types';

const Business =
    process.env.REACT_APP_SEO === 'true' && require('../components/business/Business').default;
const Executors =
    process.env.REACT_APP_SEO === 'true' && require('../components/executors/Executors').default;
const Blog = process.env.REACT_APP_SEO === 'true' && require('../components/blog/Blog').default;
const Legal = process.env.REACT_APP_SEO === 'true' && require('../components/legal/Legal').default;

const pages = {
    'public-business': {
        render(this: PublicI) {
            return (
                <div className="public__pageBox">
                    {new LazyPage({ context: this }).renderPage('public-business', Business)}
                </div>
            );
        },
    },
    'public-executors': {
        render(this: PublicI) {
            return (
                <div className="public__pageBox">
                    {new LazyPage({ context: this }).renderPage('public-executors', Executors)}
                </div>
            );
        },
    },
    'public-blog': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-blog', Blog);
        },
    },
    'public-legal': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-legal', Legal);
        },
    },
} as const;

export default pages;
